import Upsertable from '@/models/Upsertable'
import { useTrainingScheduleStore } from '@/stores/trainingScheduleStore'
import { useTrainingCourseStore } from '@/stores/trainingCourseStore'
import { useDepotStore } from '@/stores/depotStore'
import TrainingAttendance from '@/models/TrainingAttendance'
import { useModelName } from '@/composables/useModelName.js'
import { ModelRegistry } from '@/models/modelRegistry.js'

export default class TrainingSchedule extends Upsertable {
  static store() {
    return useTrainingScheduleStore()
  }

  store() {
    return TrainingSchedule.store()
  }

  static all() {
    return TrainingSchedule.store().getAll
  }

  static find(uuid) {
    const obj = TrainingSchedule.store().find(uuid)
    let training_schedule = new TrainingSchedule()
    return Object.assign(training_schedule, obj)
  }

  getTrainingCourseName() {
    const trainingCourseStore = useTrainingCourseStore()
    const trainingCourse = trainingCourseStore.find(this.training_course_uuid)

    return trainingCourse.name
  }

  getDepotName() {
    const depotStore = useDepotStore()
    const depot = depotStore.find(this.depot_uuid)
    return depot.name
  }

  attendees() {
    let attendees = TrainingAttendance.store().findAllByScheduleUuid(this.uuid)
    let attendeeObjects = []
    attendees.forEach(function (item) {
      if(item.status === false) return;
      attendeeObjects.push(Object.assign(new TrainingAttendance(), item))
    })
    return attendeeObjects
  }
}

useModelName(TrainingSchedule, "TrainingSchedule")
ModelRegistry.register(TrainingSchedule, "TrainingSchedule")